import { isHomePersonalization } from '../home/homeRefresh';

export function isExploreSummary(key, kind = 'album') {
  if (key[0] !== 'web-parity') return false;
  return (
    kind === 'playlist' || kind === 'region'
      ? ['explore']
      : ['explore', 'recent-reviews', 'timeline-preview']
  ).includes(key[1]);
}
// Cancel reads started before a successful mutation; otherwise a late response can
// replace the new result or mark the old snapshot fresh for another five minutes.
export async function invalidateExploreSummary(client, kind = 'album') {
  const filter = {
    predicate: ({ queryKey }) =>
      isExploreSummary(queryKey, kind) || isHomePersonalization(queryKey, kind),
  };
  await client.cancelQueries(filter);
  await client.invalidateQueries(filter);
}
